<template>
  <div class="view">
    <header>

      <!-- <h1>Restitution</h1> -->


      <!-- <model-viewer
      class="my-8 text-center fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full px-6"
      ref="mv"
      id="model-viewer"
      src="https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-v3-draco.gltf"
      ios-src="https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-TE.usdz"
      ar ar-modes="quick-look"
      ar-scale="auto"
      alt="The Collection"
      >
        <div id="error" class="hide">AR is not supported on this device</div>

        <button slot="ar-button" style="background-color: white; border-radius: 4px; border: none; position: absolute; top: 16px; right: 16px; ">
            👋 Activate AR
        </button>
        <a
        slot="ar-button"
        :class="{
          'opacity-25': !isTouch,
          'pointer-events-none': !isTouch
          }"
        class="inline-block w-auto mx-auto border_border-blue bg-blue text-white px-4 py-2 text-2xl serif -tracking-wide" >
          Participate in AR
        </a>

      </model-viewer> -->

      <div
      class="my-8 text-center fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full px-6 pb-16" v-show="1"
      >
        <div class="serif max-w-lg mx-auto text-3xl mb-8 text-white" v-if="!isTouch">
          AR is not supported on this device. To view The Collection in AR, open this experience on your mobile
        </div>

        <div class="text-center mx-auto text-3xl my-8" v-if="!isTouch">
          <img src="/images/QR-restitution.png" alt="" class="block mx-auto">
        </div>

        <div class="serif mx-auto text-2xl max-w-3xl lg:max-w-4xl lg:text-4xl mb-8 text-white" v-if="isTouch&&!isInAppBrowser">
          <span class="inline-block mb-2">Imagine restitution in your daily environment. </span>
          <span class="inline-block mb-2">To participate in the artwork tag <a href="https://instagram.com/janeryan_williamsaunders" rel="nofollow noopener" target="_blank">@janeryan_williamsaunders</a> on instagram and use <em>#digitalrestitution</em> and <em>#isauli</em></span>
        </div>

        <div class="serif mx-auto text-3xl max-w-3xl lg:max-w-4xl lg:text-4xl mb-8 text-white" v-if="isTouch&&isInAppBrowser">
          Please open this page on <span v-if="OperatingSystem=='iOS'">Safari</span><span v-else>Chrome</span> for augmented reality experience
        </div>

        <!-- <a
        v-if="isTouch"
        rel="ar"
        :class="{
          'opacity-25': !isTouch,
          'pointer-events-none': !isTouch
          }"
        class="inline-block w-auto mx-auto border_border-blue bg-blue text-white px-4 py-2 text-2xl serif -tracking-wide"
        href="https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-TE.usdz"
        >
          Participate in AR
        </a> -->
        <model-viewer
        class="block w-full"
        ref="mv"
        id="model-viewer"
        xsrc="https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-v3-draco.gltf"
        ios-src="https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-TE.usdz"
        poster="https://janeryanandwilliamsaunders.com/ar-poster.png"
        ar ar-modes="quick-look"
        ar-scale="auto"
        alt="The Collection"
        style="height:50px;width: 200px;margin: auto;"
        disable-pan
        disable-tap
        disable-zoom
        reveal="manual"
        :class="{
          'opacity-0': !canActivateAR,
          'opacity-100': canActivateAR
        }"
        >
          <a
          slot="ar-button"
          :class="{
            'opacity-25': !isTouch,
            'pointer-events-none': !isTouch
            }"
          class="inline-block w-full h-full mx-auto border_border-blue bg-blue text-white px-4 py-2 text-2xl serif -tracking-wide" >
            Participate in AR
          </a>

        </model-viewer>

      </div>

    </header>
  </div>
</template>

<script>
// import Flickity from 'vue-flickity';
// import 'flickity-imagesloaded'
import '@google/model-viewer';

import mdFile from '@/markdown/about.md'
// @ is an alias to /src
export default {
  name: 'Restitution',

  components: {
    // Flickity
  },

  data () {
    return {
      text: '',
      canActivateAR: false,
      flickityOptions: {
        // selector: '.item',
        cellAlign: 'center',
        draggable: true,
        pageDots: false,
        prevNextButtons: false,
        pauseAutoPlayOnHover: true,
        setGallerySize: true,
        bgLazyLoad: 1,
        wrapAround: true, // true
        freeScroll: true,
        imagesLoaded: true,
        // autoPlay: false,
        // selectedAttraction: 0.01,
        // friction: 0.15,
        contain: true,
        // any options from Flickity can be used
      }
    }
  },

  mounted () {

    const ModelViewerElement = this.$refs.mv

    if (ModelViewerElement.canActivateAR) {
      this.canActivateAR = true
    }

    setTimeout(() => {
      if (ModelViewerElement.canActivateAR) {
        this.canActivateAR = true
      }
    }, 1000)
    // ModelViewerElement.dracoDecoderLocation = '/draco/';

    // console.log(ModelViewerElement)
    // debugger
    // ModelViewerElement.addEventListener('ar-status', (event) => {
    //   console.log(event.detail.status)
    //   alert(event.detail.status)
    //   if(event.detail.status === 'failed'){
    //     const error = document.querySelector("#error");
    //     error.classList.remove('hide');
    //     error.addEventListener('transitionend',(event) => {
    //       error.classList.add('hide');
    //     });
    //   }
    // });
  },

  computed: {
    stage () {
      return this.$store.state.stage
    },
    md () {
      return mdFile
    },
    isTouch () {
		  return (('ontouchstart' in window) ||
		     (navigator.maxTouchPoints > 0) ||
		     (navigator.msMaxTouchPoints > 0));
    },
    isInAppBrowser () {
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      let isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
      let isFacebook = (ua.indexOf('Facebook') > -1) ? true : false;
      let isMessenger = (ua.indexOf('Messenger') > -1) ? true : false;
      // if (document.documentElement.classList){
      // 	if (isInstagram||isFacebook||isMessenger) {
      // 		// window.document.body.classList.add('instagram-browser');
      //     return true
      // 	} else {
      //     return false
      //   }
      // }
      // return true
      return (isInstagram||isFacebook||isMessenger) ? true : false
    },
    OperatingSystem () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
          return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }

      return "unknown";
    }
  },
  methods: {
    getUrl (url) {
      return `media/${url}`
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  pointer-events: auto;
  max-width: 100%;
  width: 100%;
  // background: rgba(38, 35, 34, 1);
}

.media-viewer {
  // width: 100%;
  // margin-bottom: 100px;
  @apply flex flex-wrap justify-center py-16;
  .media {
    height: 500px;
    margin: 20px;
    width: auto;
  }
}
</style>
